// JOBE-0116: useRoster — page-session hook that pulls the project's
// visible principal universe (humans + agents) for the chip composer's
// PeopleValuePopover. Returns `{ humans, agents }` per the
// JOBE-0044.10.1 roster contract.
//
// Extracted from ProjectHomePage.jsx (JOBE-0106) without behaviour
// change so both /projects/{urn} (Screen B) and
// /projects/{urn}/entities/{kind} (Screen C / JOBE-0116) can mount
// `<EntityBrowser>` instances that need the same roster shape.
//
// Spec: specs/in-progress/JOBE-0116-project-entities-subroute.md
//       §"Component shape" + Open question 2.

import { useEffect, useState } from 'react';

export function useRoster() {
  const [roster, setRoster] = useState({ humans: [], agents: [] });
  useEffect(() => {
    const ctrl = new AbortController();
    let alive = true;
    fetch('/api/entities?type=person,agent', {
      credentials: 'same-origin',
      signal: ctrl.signal,
    })
      .then(async (res) => {
        if (!alive || !res.ok) return;
        const body = await res.json();
        if (!alive) return;
        const items = Array.isArray(body?.items) ? body.items : [];
        const humans = items.filter((e) => e?.kind === 'person' || e?.kind === 'human');
        const agents = items.filter((e) => e?.kind === 'agent');
        setRoster({ humans, agents });
      })
      .catch(() => { /* silent — roster is non-critical */ });
    return () => { alive = false; ctrl.abort(); };
  }, []);
  return roster;
}
